// extracted by mini-css-extract-plugin
export default {"category-grid":"S83KRp","categoryGrid":"S83KRp"};